module.exports = "<div *ngIf=\"show\">\n    <img [src]=\"loadingImage\" [width]=\"widthImage\"/>\n    <span style=\"color : #0054a5\" [style.font-size]=\"sizeText\">{{text}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/spinner/spinner.component.html
// module id = ../../../../../src/app/shared/components/spinner/spinner.component.html
// module chunks = main